import axios from "axios";

export class ApiController {
    static BASE_URL = process.env.VUE_APP_BASE_URL;
    //static BASE_URL = process.env.VUE_APP_SERVERS_Dev;

    static GetServers() {
        const servers = Object.keys(process.env)
            .filter(key => key.startsWith("VUE_APP_SERVERS_"))
            .map(key => {
                const name = key.replace("VUE_APP_SERVERS_", "");
                return { name, url: process.env[key] };
            }) || [];

        return servers;
    }

    static API = axios.create({
        baseURL: ApiController.BASE_URL
    });

    static ChangeApiURL(newUrl) {
        ApiController.BASE_URL = newUrl;
        ApiController.API.defaults.baseURL = newUrl;
    }

    static GetServerName(serverURL) {
        return ApiController.GetServers().find(s => s.url === serverURL)?.name;
    }
    static GetServerURL(serverName) {
        return ApiController.GetServers().find(s => s.name === serverName)?.url;
    }

}

export default ApiController.API;

